import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import {useState} from "react";
import {Switch} from "@mui/material";
import Stack from "@mui/material/Stack";
import {postRequest} from "../../../httpClient";
import {useAuth} from "oidc-react";
import {isAuthenticated} from "../../utils/security-utils";

const CreateNewsItemModal = ({ open, setOpen, reload }) => {

    const handleClose = () => {
        setOpen(false);
        setShow(true);
        setHeadline('');
        setContent('');
    };

    const [headline, setHeadline] = useState('');
    const [content, setContent] = useState('');
    const [show, setShow] = useState(true);
    const [headlineError, setHeadlineError] = useState(false);
    const [contentError, setContentError] = useState(false);

    const auth = useAuth();

    const update = () => {
        let errors = [];
        if (headline === '') {
            setHeadlineError(true);
            errors = [...errors,'headline'];
        }

        if (content === '') {
            setContentError(true);
            errors = [...errors,'content'];
        }

        if (errors.length > 0) {
            return;
        }

        if (!isAuthenticated(auth)) {
            return;
        }
        let token = auth?.userData?.access_token;

        const body = {
            headline,
            content,
            show
        }

        postRequest(`/v1/landingpage/news`,token, JSON.stringify(body))
            .then(resp => {
                if (resp.ok) {
                    reload();
                    handleClose();
                }
            })
            .catch(err => console.log(err))
    }

    return (
        <div>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{`Create news item`}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Create a news item. This news item is displayed on the main webpage as well as the admin landingpage.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="headline"
                        label={'Headline'}
                        type="text"
                        fullWidth
                        variant="standard"
                        onChange={e => setHeadline(e.target.value)}
                        error={headlineError}
                    />

                    <TextField
                        margin="dense"
                        id="content"
                        label={'Content'}
                        type="text"
                        fullWidth
                        variant="standard"
                        multiline
                        onChange={e => setContent(e.target.value)}
                        error={contentError}
                    />

                    <div style={{
                        textAlign: 'center',
                        textTransform: 'uppercase'
                    }}>
                        <Stack alignItems={"center"} direction={"row"}>
                            <span>off</span>
                            <Switch defaultChecked onChange={e => setShow(e.target.checked)}/>
                            <span>on</span>
                        </Stack>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={update}>Update</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default CreateNewsItemModal;
